module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"no data":"No data","cv_down":"Coding violations down","cv_up":"Coding violations up","ses_down":"Severe error seconds down","ses_up":"Severe error seconds up"},"de":{"no data":"Keine Daten","cv_down":"Coding violations down","cv_up":"Coding violations up","ses_down":"Severe error seconds down","ses_up":"Severe error seconds up"}}')
  delete Component.options._Ctor
}
